import { HelperCard } from '@design-system/Cards/HelperCard';
import { ScrollArea, ScrollBar } from '@design-system/ScrollArea';
import { Sheet, SheetContent, SheetDescription } from '@design-system/Sheet';
import { useState } from 'react';
import { getBoostersAndBlockersImageUrl } from '@utils/nutrition/getImageUrl';
import { Image } from '@design-system/Image';

export interface Badge {
  description: string;
  image_url: string;
  title: string;
}

interface BadgeListProps {
  badgeInfo: Badge[];
}

export const NutritionBadgeDetails = ({ badgeInfo }: BadgeListProps) => {
  const [sheetData, setSheetData] = useState<Badge | null>(null);

  const handleCardClick = (badgeItem: Badge) => {
    setSheetData(badgeItem);
  };

  const handleCloseSheet = () => {
    setSheetData(null);
  };

  return (
    <div>
      <ScrollArea className="pt-12 pb-5">
        <div className="grid grid-flow-col gap-2 justify-start">
          {badgeInfo?.map((badgeItem) => (
            <div key={badgeItem.title} className="pr-2">
              <HelperCard
                title={badgeItem.title}
                image_url={getBoostersAndBlockersImageUrl(badgeItem.image_url)}
                onClick={() => handleCardClick(badgeItem)}
              />
            </div>
          ))}
        </div>
        <ScrollBar orientation="horizontal" />
      </ScrollArea>

      {sheetData && (
        <Sheet open onOpenChange={(open) => !open && handleCloseSheet()}>
          <SheetContent variant="glass" className="pt-20 px-8 pb-8">
            <SheetDescription>
              <div className="flex flex-col">
                {sheetData?.image_url && (
                  <div className='flex justify-center'>
                    <Image
                      className="w-[11.25rem] h-[11.25rem] object-cover"
                      src={getBoostersAndBlockersImageUrl(sheetData?.image_url)}
                      alt={sheetData?.title}
                    />
                  </div>
                )}
                <span className="typography-h1 text-primary">
                  {sheetData?.title}
                </span>
                <span className="typography-body text-secondary pt-6">
                  {sheetData?.description}
                </span>
              </div>
            </SheetDescription>
          </SheetContent>
        </Sheet>
      )}
    </div>
  );
};
